const es = {
  Deposit: "Depósito",
  startedAt: "Empezó en",
  noRollover: "Sin Rollover",
  completeness: "Completitud",
  clickHere: "Pulse aquí",
  doYouHavePromoCode: "¿Tiene un código promocional?",
  finalizedIn: "Finalizado en",
  provider: "Proveedor",
  consolidatedValue: "Valor Consolidado",
  entryId: "ID de Entrada",
  registrationDate: "Fecha de Registro",
  depositID: "ID de depósito",
  betStatus: {
    Pending: "Pendiente",
    Lost: "Perdido",
    Awarded: "Galardonado",
    Cashout: "Cerrado"
  },
  idBet: "ID Apuesta",
  sport: "Deporte",
  cancellation: "Cancelación",
  betDate: "Fecha de apuesta",
  infoPrizeValue: "Valor en premios",
  resultDate: "Fecha del resultado",
  numberOfGames: "Número de partidas",
  multiplier: "Multiplicador",
  consultedOn: "Consultado el",
  download: "Descargar",
  noDataFount: "¡No se encontraron datos!",
  loadingData: "Cargando datos...",
  deposits: "Depósitos",
  amountOfDeposits: "Cantidad de depósitos",
  onlineBalance: "Saldo en Línea",
  cellPhone: "Móvil",
  usersPlurals: "Usuario | Usuarios",
  depositsPlurals: "Deposit | Deposits",
  noQuery: "No se ha realizado ninguna consulta",
  lastLogin: "Ultimo acceso",
  birthday: "Nacimiento",
  reports: "Informes",
  users: "Usuarios",
  sortBy: "Ordenar por",
  affiliateCampaign: {
    title: "Campañas",
    newCampaign: "Nueva campaña",
    name: "Nombre de la campaña",
    numberOfClicks: "Número de clics",
    betQty: "Cant. de apuestas",
    usersQty: "Cant. de usuarios",
    firstDepositQty: "Cant. de primer depósito",
    channel: "Canal",
    activate: "Activar",
    deactivate: "Desactivar",
    others: "Otros",
    socialMedia: "Red social",
    campaignCode: "Código de la campaña",
    createCampaign: "Crear campaña",
    activeCampaigns: "Campañas activas",
    othersInputText: "Indique otra red social",
    copyLink: "Copiar enlace",
    goToCampaigns: "Ir a las campañas",
    campaignCreatedSuccessfully: "¡Campaña creada con éxito!",
  },
  noTitle: "Sin título",
  gamesSingularPlural: "Juegos | {count} Juego | {count} Juegos",
  includedGames: "Juegos incluidos en la campaña",
  roundsQuantityTip:
    "Total de rondas disponibles para todos los juegos incluidos en esta campaña.",
  roundsQuantity: "Total de rondas disponibles",
  loginExemptPlayer: "Iniciar sesión como jugador exento",
  titleDialogBlockUser: "Advertencia: {idReason} bloqueado",
  messageDialogBlockUser: {
    securityReason:
      "Por razones de seguridad, la función {idReason} ha sido bloqueada temporalmente.",
    getExplainingWithSupport:
      "Contacte a nuestro soporte para resolver preguntas y tomar las acciones necesarias.",
    contactSupport: "Contactar con soporte",
    reason: "Razón: ",
    messagesTranslate: {
      thirdPartyData:
        "Para garantizar la seguridad financiera, hemos suspendido los retiros que involucran datos de terceros.",
      violationTermsAndConditions:
        "Para mantener un ambiente justo, suspendemos cuentas y bloqueamos retiros que no siguen nuestras reglas y términos de uso.",
      maliciousBets:
        "Hemos suspendido los retiros relacionados con apuestas maliciosas para mantener un entorno de apuestas justo y transparente.",
      multiAccounts:
        "Las suspensiones de acciones de retiro ocurren cuando el mismo usuario/grupo utiliza varias cuentas para obtener ganancias indebidas.",
      suspiciousBehavior:
        "Para la seguridad financiera de todos, hemos suspendido los retiros relacionados con comportamientos sospechosos o actividades fraudulentas.",
      affiliateAccount:
        "Esta es una cuenta de socio. Para retirar sus ganancias, comuníquese con la administración.",
      exemptBetCasino: "Exención de apuestas de casino",
      suspiciousActivityDetected: "Detección de actividad sospechosa.",
      abuseOfSystemCrashes: "Abuso de fallos del sistema.",
      gamblerShowingCompulsiveBehavior:
        "Jugador que muestra un comportamiento compulsivo.",
      playerAttemptingToUseMethodsThatViolate:
        "El jugador intenta utilizar métodos que violan nuestras políticas y términos de uso.",
      moduleUnavailableToThePlayer: "Módulo no disponible para el reproductor.",
    },
  },
  noSportsPromoFound:
    "No hay promociones disponibles para deportes en este momento.",
  searchByTitleAndGame: "Buscar por título o nombre del juego",
  ativa: "Activa",
  daysRemaining: "días restantes | día restante | {count} días restantes",
  forYouOpeningTxt: {
    intro:
      "Hemos preparado promociones especiales solo para ti, ¡todas juntas en un mismo lugar!",
    howToWinFreeSpins: "¿Cómo conseguir las tiradas gratis?",
    development: `Para unirte a la diversión, ¡solo tienes que hacer clic en 'Reclamar' en las promos que más te llamen la atención!<br><br> Después de eso, las tiradas se añadirán automáticamente a tu cuenta para que las uses exclusivamente en los juegos seleccionados de la promo que elijas, y estarán disponibles para disfrutarlas hasta que venzan.`,
    conclusion:
      "¡Adelante, sácales el máximo provecho y diviértete a lo grande!",
  },
  gotIt: "¡Entendido!",
  forYou: "Para ti",
  ativas: "Activas",
  sumFirstDeposits: "Suma de primeros depósitos",
  winAmount: "Cantidad ganada",
  loadMore: "Carga Más",
  myPromotionsOpeningTxt:
    "Hemos separado las promociones especialmente para usted, ¡todas reunidas en un solo lugar! <br /><br /> <b>¿Cómo ganar tiradas gratis?</b> <br /> Para participar, ¡sólo tiene que hacer clic en Reclamar en las promociones que más le convengan! <br /><br /> Después de eso, las tiradas se acreditarán automáticamente en su cuenta para uso exclusivo en los juegos seleccionados de la promoción elegida, y tendrán un período para ser disfrutadas hasta que caduquen. <br /><br /> ¡Disfrute y diviértase!",
  recommended: "Recomendado",
  recommendedForYou: "Recomendados para ti",
  claim: "Reivindicar",
  theaterMode: "Modo Teatro",
  qtdDeposits: "Cantidad de Depósitos",
  registerDate: "Fecha de Registro",
  noDataForthisQuery: "No hay datos para esta consulta.",
  notFound: "No encontrado.",
  cpaValue: "Valor de CPA",
  firstDeposit: "Primer Depósito",
  gameNotAvailable: "Juego no disponible en este momento.",
  pleaseTryAgainLater: "Por favor, inténtalo nuevamente más tarde.",
  typeOfCPA: "Tipo de CPA",
  playerId: "ID Jugador",
  percent: "Porcentaje",
  fixedCommission: "Comisión Fija",
  valueCpa: "Valor CPA",
  redeemTokenTitle: "Canjear token",
  allowDeactivateCurrentPromo:
    "Soy consciente de que al canjear mi token, la promoción actual se desactivará. Y se perderán todos los progresos anteriores, incluidas las apuestas que aún estén pendientes de liquidación.",
  infoRedeemToken: "Una vez canjeados, sus promociones aparecerán en ",
  redeem: "Rescate",
  insertToken: "Inserte su token",
  menuRedeemToken: "Canjear <br /> su token",
  redeemToken: "Canjea tu token aquí",
  minPlayersCommissionTip:
    "Para que se ponga en marcha, es necesario alcanzar un mínimo de usuarios activos.",
  minimum: "Mínimo",
  activeUsers: "Usuarios activos",
  remainingActivePlayers:
    "Se ha alcanzado la cantidad mínima de usuarios activos. | falta {remainingUsers} usuario activo. | faltan {remainingUsers} usuarios activos.",
  frequentlyAskedQuestions: "Duvidas frequentes",
  depositClinPaysConfirmed: "Depósito confirmado.",
  // clinPays: {
  cardValidDate: "Escriba el mes correctamente",
  nameAsShownOnCard: "Nombre como se muestra en la tarjeta",
  userAnotherCard: "Usar otra tarjeta",
  clinPaysFooter:
    "ClinPays: garantiza transacciones más seguras y la detección temprana de transacciones fraudulentas. Cuenta con más de cuatro años de experiencia en el rubro, comprometidos a brindarte tecnologías de pago y productos innovadores con la más alta seguridad establecida por marcas internacionales. ClinPays está certificado según el estándar PCI DSS (Payment Card Industry Data Security Standard) fundado por varias instituciones, incluidas Visa y Mastercard. Además, su negocio puede ser gratuito al autenticar cada transacción con 3DS 2.0.",
  saveCardText: "Guarde los datos de la tarjeta para futuros depósitos",
  securityCode: "Código de seguridad",
  cvvTooltipText:
    "Ingrese el código de 3 dígitos (CVV) que se encuentra en el reverso de la tarjeta",
  cardValidity: "Validez",
  cardNumber: "Numero de tarjeta",
  nameOfCardHolder: "Nombre del titular de la tarjeta",
  // },
  seeAllGamesCategory: "+ Ver todo",
  feeValue: "Valor de la Tarifa",
  searchByGame: "Buscar por Juego",
  noLoadPaymentMethods:
    "No se pueden cargar los métodos de pago. Vuelva a intentarlo más tarde.",
  noLoadLicenses:
    "No se pueden cargar las licencias. Vuelva a intentarlo más tarde.",
  noLoadPartner:
    "No se pueden cargar los socios. Vuelva a intentarlo más tarde.",
  paymentMethods: "MÉTODOS DE PAGO",
  maximumDepositAmount: "El monto máximo de depósito es R$ {value}.",
  minimumDepositAmount: "El monto mínimo de depósito es R$ {value}.",
  newDeposit: "Nuevo Depósito",
  congratsDeposit:
    "¡Gracias! Ahora puedes disfrutar de lo mejor de Deportes y Entretenimiento. Hagan sus apuestas y bueno ¡Suerte!",
  depositConfirmed: "Depósito PIX confirmado.",
  pixCopyPaste: "Copiar/Pegar código Pix",
  depositPaymentProviderRules: {
    PixPay4Fun:
      "PIX a través de Pay4Fun no acepta claves aleatorias,<br />solo claves tipo <strong>CPF</strong>, <strong>email</strong> o <strong>teléfono</strong>.<br />Verifique su registro.",
    PixPaybrokersBrasilCash:
      "Los depósitos se realizan a través de Pix.<br />Es obligatorio tener su <strong>CPF</strong> registrado.",
    PixPaguePay:
      "Los depósitos se realizan a través de Pix.<br />Es obligatorio tener su <strong>CPF</strong> registrado.",
    PixPagFast:
      "Los depósitos se realizan a través de Pix.<br />Es obligatorio tener su <strong>CPF</strong> registrado.",
  },
  resendEmailTip:
    "Sugerencia: cuando solicite reenviar un correo electrónico, ¡siempre verifique el último correo electrónico enviado!",
  dateExpiration: "Fecha de expiración",
  walletPay4FunFooter1:
    "¡Pay4Fun es una billetera 100% virtual, segura y rápida para facilitar tus transacciones en Internet! Y lo mejor de todo: sin costo* para tus depósitos a través de Pix, transferencia bancaria, boleto o tarjeta de crédito. Ya tienes una cuenta Pay4Fun , seleccione la cantidad deseada y haga clic en 'Depositar'. Será redirigido al sitio web de Pay4Fun para completar la transacción y será redirigido a",
  walletPay4FunFooter2:
    "automáticamente cuando completa su transacción en Pay4Fun. Para abrir su cuenta Pay4Fun u obtener más información, visite: www.p4f.com o descargue la aplicación.",
  walletPay4FunFooter2_1: "*en algunos casos, se aplican tarifas bancarias.",
  depositWalletPay4Fun: "Depósito através de Pay4Fun Wallet",
  walletWithdrawalPay4Fun: "Retiro a Pay4Fun Wallet",
  paagDeposit: "Depósito através de Paag",
  paguePayDeposit: "Depósito através de Pague Pay",
  pagFastDeposit: "Depósito através de PagFast",
  paagWithdraw: "Retiro através de Paag",
  paguePayWithdraw: "Retiro através de Pague Pay",
  pagFastWithdraw: "Retiro através de PagFast",
  paagFooter: `Paag es una empresa especializada en soluciones de pago para el
  de iGaming y apuestas deportivas. Centrado en cumplimiento y tarifas
  competitivo, Paag ofrece soluciones eficientes para llevar a cabo
  transacciones financieras de forma segura.`,
  paguePayFooter:
    "PaguePay ofrece soluciones de gestión de pagos electrónicos (eFX) para agilizar las entradas y salidas de fondos, facilitando la realización de compras en plataformas globales. Integramos nuestra tecnología con la suya, lo que permite ofrecer múltiples opciones financieras a sus usuarios directamente en su aplicación.",
  pagFastFooter: "Pagfast ofrece soluciones de gestión de pagos electrónicos (eFX) para facilitar las entradas y salidas de fondos, simplificando la realización de compras en plataformas globales. Combinamos nuestra tecnología con la suya, permitiendo múltiples opciones financieras para sus usuarios directamente en su aplicación.",
  minValueDialog: "Min. $",
  maxValueDialog: "Max. $",
  infoValue: "Informar el valor",
  bonusConversionConfirmation: "Confirmación de Conversión de Bono",
  areYouSureYouWantToConvert: "Tiene certeza de que quieres convertir",
  ofBonusIn: "de bono en",
  ofRealBalance: "de saldo real",
  toRealBalance: "para saldo real",
  walletWithdrawalFooter1:
    "¡Pay4Fun es una billetera 100% virtual, segura y rápida para facilitar tus transacciones en Internet! Y lo mejor de todo: sin costo* para tus depósitos vía Pix, transferencia bancaria, comprobante bancario o tarjeta de crédito. Si ya tiene una cuenta Pay4Fun, seleccione la cantidad deseada, complete los detalles de su cuenta Pay4Fun y haga clic en 'Retirar'. Deberá esperar el procedimiento y la confirmación del retiro por parte del departamento financiero de",
  walletWithdrawalFooter2:
    "Después de la confirmación, el monto retirado se transferirá a su cuenta Pay4Fun. Para abrir su cuenta Pay4Fun u obtener más información visite: www.p4f.com o descargue la aplicación.",
  walletWithdrawalFooter2_1: "*En algunos casos, se aplican tarifas bancarias.",
  paybrokersFooter1:
    "Paybrokers brinda servicios de Facilitación de Pagos (eFx) a través de su plataforma electrónica moderna y segura para depósitos y retiros, facilitando las compras en línea en sitios internacionales.",
  paybrokersFooter2:
    "Paybrokers sigue las reglas del Banco Central de Brasil, así como las mejores prácticas de pago internacionales.",
  settings: "Configuración",
  invalidPixKey: "¡Clave PIX no válida! Solo CPF, email o teléfono.",
  needToRegisterPixKey: "Necesitas registrar tu clave PIX",
  noPaymentMethodsMsg:
    "No hay métodos de pago disponibles en este momento. ¡Inténtalo de nuevo más tarde!",
  depositPixByPayBrokers: "Depósito PIX a través de Paybrokers",
  brazilCashDeposit: "Depósito a través de Brasil Cash",
  brazilCashWithdraw: "Retiro através de Brasil Cash",
  depositPixByPay4FunGo: "Depósito a través de Pay4Fun GO",
  withdrawalByPayBrokers: "Retiro através de Paybrokers",
  withdrawalByPay4FunGo: "Retiro através de Pay4Fun GO",
  pay4funWithdrawlFooterText1:
    "Pay4Fun GO es un pago directo, seguro y rápido, ¡facilitando tus transacciones en Internet! Y lo mejor de todo: sin costo* para tus retiros a través de Pix o transferencia bancaria. Solo selecciona el monto deseado y haz clic en 'Retirar'. ser redirigido para completar la transacción. Deberá esperar el procedimiento y la confirmación del retiro por parte del departamento financiero de ",
  pay4funWithdrawlFooterText2:
    "Después de la confirmación, el monto retirado se depositará en su cuenta bancaria. *En algunos casos, se aplican comisiones bancarias.",
  pay4funDepositFooterText1:
    "Pay4Fun GO es un pago directo, seguro y rápido, ¡facilitando tus transacciones en Internet! Y lo mejor de todo: sin costo* para tus depósitos a través de Pix, transferencia bancaria. Solo selecciona el monto deseado y haz clic en 'Depositar'. será redirigido para completar la transacción. Tan pronto como complete el pago de la forma elegida, se liberará automáticamente el ",
  pay4funDepositFooterText2:
    "*En algunos casos, se aplican tarifas bancarias. **El tiempo de liberación varía según el método de pago elegido.",
  cashoutAvailable: "Cashout Disponible",
  eventNumber: "Numero de Eventos",
  useBonus: "Usar bonificación",
  bankVerificationIntroductionText:
    "La verificación del banco verifica si la clave de imagen registrada coincide con uno de los bancos autorizados por nuestro sistema.",
  pixEditBlocked:
    "La edición de datos bancarios está bloqueada, comuníquese con soporte para actualizar sus datos.",
  //   bankVerificationIntroductionText:
  //     "La verificación del banco verifica si la clave de imagen registrada coincide con uno de los bancos autorizados por nuestro sistema.",
  bankVerificationHowDoesItWorkText: "¿Cómo funciona?",
  bankVerificationText:
    "Haremos un retiro de BRL 1.00 (Un Real) para validar si su pix key pertenece a uno de los Bancos autorizados. Si tiene éxito, el usuario podrá retirar normalmente. hacer retiros, hasta que cambie sus Datos Financieros e indicar una pix key que pertenezca a uno de los Bancos autorizados por nuestro sistema.",
  notRegistered: "No registrado",
  profileBankVerificationDenied:
    "¡Verificación denegada! Verifique si hay errores en la clave de pix informada y/o si el banco registrado se encuentra entre los aceptados en nuestro sistema.",
  successVerification: "¡Verificación exitosa!",
  bankVerified: "Banco verificado",
  pendingVerification: "Pendiente de verificación bancaria.",
  processingVerification: "procesamiento de verificación bancaria",
  verificationDenied: "Verificacion denegada, intente nuevamente.",
  maybeYouNeedChangeYourData: "Es posible que deba cambiar sus datos bancarios",
  bankVerificationTitle: "Verificación bancaria",
  bankVerificationLearnMore:
    "La verificación bancaria comprueba si la clave de imagen registrada coincide con el banco. El Usuario no puede retirarse hasta que se complete la verificación. Si tiene éxito, el usuario podrá retirarse normalmente. De ser denegada, el usuario no podrá realizar retiros, hasta que cambie sus datos financieros e indique un nuevo banco que se encuentre en la lista de bancos disponibles en nuestro sistema.",
  verifyBank: "Verificar",
  goToProfile: "ir al Pperfil",
  learnMore: "Sepa mas",
  bankVerificationPending:
    "¡Se requiere verificación bancaria para hacer retiros!",
  bankVerificationProcessing:
    "Tramitación de verificación bancaria. Espera unos momentos.",
  bankVerificationDenied:
    "La verificación bancaria fue denegada. Vaya a 'Perfil' y cambie los Datos financieros",
  searchYourBank: "Busca el banco de tua clave pix",
  showBalance: "Mostrar saldo",
  hideBalance: "Ocultar saldo",
  refreshBalance: "Actualizar saldo",
  confirmByEmail: "Confirmar por correo electrónico",
  affiliateCode: "Código de Afiliación (Opcional)",
  msgFavoritesLimit: "Has alcanzado el número máximo de favoritos",
  finished: "Cerrada",
  finishedPlural: "Cerradas",
  favorites: "Favoritos",
  noDataFound: "Datos no encontrados",
  minus: "menos",
  report: "Reporte",
  accountDisabled: "Cuenta deshabilitada",
  disabledByLoginAttempts:
    "Bloqueado por intentos de inicio de sesión superados",
  totalAffiliates: "Total de afiliados",
  disabled: "Desactivado",
  accountConfirmation: "Confirmación de cuenta",
  blocked: "Bloqueado",
  suspended: "Suspendido",
  lastAccess: "Último acceso",
  depositBalance: "Saldo del depósito",
  bonusBalance: "Saldo de bonificación",
  dateRegistration: "Fecha de registro",
  noRegister: "No hay registro",
  affiliatedPlayers: "Jugadores afiliados",
  rowsPerPage: "Líneas por página:",
  affiliates: "Afiliados",
  noSearchPerformed: "Ningúna búsqueda realizada",
  changeOddsConfigurationTooltip: "Cambios de cotización",
  doNotAcceptOddsChanges: "No aceptar cambios en las cuotas",
  acceptAboveOddsChanges: "Aceptar cuotas más altas",
  acceptAnyOddsChanges: "Aceptar cualquier cuota",
  beCarefulLoginAttemptsTitle: "Ten cuidado",
  beCarefulLoginAttemptsContentAfterRequisition1:
    "Olvida su contraseña demasiadas veces. Si sigues confundiendo tu contraseña, su cuenta será bloqueada.",
  beCarefulLoginAttemptsContentAfterRequisition2:
    "Puedes recuperar tu contraseña tu cuenta usando el botón debajo, o contactando a soporte.",
  beCarefulLoginAttemptsContentBeforeRequisition1:
    "Está intentando iniciar sesión con la misma contraseña que acaba de intentar. Si sigues confundiendo tu contraseña, su cuenta será bloqueada.",
  beCarefulLoginAttemptsContentBeforeRequisition2:
    "Puedes recuperar tu contraseña tu cuenta usando el botón debajo, o contactando a soporte.",
  updatedAt: "Actualizado el",
  read: "Leído",
  notRead: "No leído",
  name: "Nombre",
  loginCreditBuyer:
    "Insira el inicio de sesión del usuario para vender crédito",
  valueCredit: "Valor",
  confirmYourPassword: "Confirme sua senha",
  confirmYourPasswordDescription:
    "Deberá confirmar su contraseña para realizar esta acción.",
  noTime: "No hay tiempo",
  addiction: "Adicto o en riesgo de convertirse",
  dontWantToSay: "No quiero decir",
  instatisfactionOperator: "Insatisfecho con el operador",
  instatisfactionBonus: "Insatisfecho con la política de bonificación",
  other: "Otro",
  suspensionReason: "Razón de La Suspensión",
  selectAReasonToSuspend: "Seleccione un motivo para la suspensión",
  suspensionReasonDescription: "Inserte una breve razón para la suspensión",
  autoexclusionReason: "Razón de La Autoexclusión",
  autoexclusionReasonDescription:
    "Inserte una breve razón para la autoexclusión",
  unlimited: "Ilimitado",
  confirmation: "Confirmación",
  suspendAccount: "Suspender mi cuenta hasta esta fecha",
  autoexcludeAccount: "Autoexcluir mi cuenta hasta esta fecha",
  suspendQuestion: "¿Quiere suspender su cuenta?",
  autoExcludeQuestion: "¿Quiere autoexcluir su cuenta?",
  areaForPlayersLogged: "Debe iniciar sesión para suspender la cuenta",
  welcomeMsg: "Bienvenido a tu aplicación Vue.js",
  selection: "selección",
  ticket: "Billete",
  no_selection: "Sin selección",
  textPhonePreBet:
    "Complete su teléfono para recibir el código de pre-apuesta por SMS.",
  phone: "Teléfono",
  phoneOrName: "Teléfono o nombre",
  betBonus: "Bono de apuesta",
  value: "Valor",
  betWithBonus: "¿Apostar con bonificación?",
  possibleGain: "Posible Ganancia",
  totalOdds: "Probabilidades Totales",
  acceptChanges: "Aceptar cambios",
  deposit: "Depositar",
  bet: "Apostar",
  preBet: "Apuesta previa",
  depositToBet: "Depositar para apostar",
  betGreaterthanBonus: `El monto de su apuesta es mayor que su bono disponible`,
  pleaseLoginAgaing: "¡Por favor, inicie sesión de nuevo!",
  serverErrorTryAgain: "¡Por favor, inicie sesión de nuevo!",
  playerHasregisterMsg:
    "Identificamos que ya tiene un registro con nosotros, para continuar con el inicio de sesión.",
  userFound: "Usuario encontrado",
  phoneIsMandatory: "¡Completar el número de teléfono es obligatorio!",
  rulesEventsMaxAlert: {
    term1: "Hola, tienes el límite de",
    term2:
      "eventos por apuesta, elimine algunos eventos del carrito para continuar",
    term3: "(Existe",
    term4: "eventos en el carrito en este momento.)",
  },
  checkPossibleGainAlert: `Has alcanzado la máxima ganancia posible`,
  checkBetAmountAlert: "Hola, la apuesta mínima es",
  maximumMutiplierMsg: "Has alcanzado el multiplicador máximo",
  noEventsFound: "¡No se encontraron eventos!",
  loading: "Cargando...",
  today: "Hoy",
  tomorrow: "Mañana",
  currentPassword: "Contraseña actual",
  infoNewPassword: "Ingrese una nueva contraseña",
  consultBet: "Consultar apuesta",
  allSports: "TODOS LOS DEPORTES",
  specialLists: "LISTAS ESPECIALES",
  live: "En vivo",
  home: "Comienzo",
  searchEvent: "Búsqueda de Evento",
  sports: "Deportes",
  knowUs: "Encuéntranos",
  register: "Registrar",
  login: "Iniciar Sesión",
  loginInput: "Login",
  playResponsibly: "Juega responsablemente.",
  prohibitedForUnder18: "Prohibido para menores de 18 años.",
  partnersAndSponsorships: "Socios y patrocinios",
  allRightsReserved: "Todos los derechos reservados.",
  about: "Sobre",
  nameAndLastName: "Nombre y apellido",
  dateOfBirth: "Fecha de nacimiento",
  optionalEmail: "Correo electrónico (Opcional)",
  password: "Contraseña",
  loginOrEmail: "Login/Email",
  confirmPassword: "Confirmar Seña",
  consultYourAccountText: "Consulta tu cuenta por SMS.",
  consultYourAccountTextSMS: "Verifique su cuenta por SMS.",
  consultYourAccountTextEmail: "Verifique sua conta por Email.",
  weSendAEmail:
    "Te enviaremos el código a tu correo electrónico registrado. Confirma el registro para acceder a tu cuenta.",
  accountVerificationByEmail:
    "Verifique su cuenta haciendo clic en el enlace enviado por mensaje de correo electrónico.",

  weSendASMS:
    "Le enviaremos un SMS a su celular registrado. Confirme el registro para acceder a su cuenta.",
  weSendASMSOrEmail:
    "Le enviaremos un SMS o un correo electrónico. Confirme su registro para acceder a su cuenta",
  welcomeToTheNewPlatform: "Bienvenido a la nueva plataforma!",
  setNewPasswordByEmail: "Registra tu nueva contraseña por Email.",
  setNewPasswordByClickingLinkEmail:
    "Registra tu nueva contraseña haciendo clic en el enlace anviado a tu email: ",
  certifyIamOfLegalAge:
    "Certifico que soy mayor de 18 años y he leído y aceptado",
  generalTermsAndConditions: "Términos y Condiciones Generales",
  and: "y",
  agent: "Agente",
  registrationCompleted: "¡Registro completado!",
  important: "¡Importante!",
  accountVerificationBySMS:
    "Verifique su cuenta haciendo clic en el enlace enviado por mensaje SMS.",
  resendEmail: "Reenviar Email",
  hinitLogin:
    "El inicio de sesión se utiliza para iniciar sesión en su cuenta.",
  loginAsACollaborator: "Iniciar sesión como colaborador",
  registration: "Registro",
  trackYourBets: "Seguimiento de sus apuestas",
  accessCredential: "CREDENCIAL DE ACCESO",
  UseYourPhoneToEnterOurWebsite:
    "Utilice su número de teléfono para ingresar a nuestro sitio web.",
  createSecure8DigitPassword:
    "Cree una contraseña segura de 8 dígitos con letras y números.",
  hinitPassword:
    "Informe uma senha com 8 caracteres contendo letras e números.",
  save: "ahorrar",
  wait: "Espera",
  required: "Campo obligatorio",
  requiredInput: "Campo obligatorio *",
  repeatThePassword: "La confirmación debe ser la misma que la contraseña.",
  all: "Todos",
  logingYourPhone: "Iniciar sesión (su teléfono)",
  validPhone: "Ingrese un teléfono válido",
  registrationBeenCompleted: "¡Felicitaciones, su registro ha sido completado!",
  emailAlreadyRegistered: "Correo electrónico ya registrado",
  loginAlreadyRegistered: "Login  ya registrado en sistema",
  forgotYourPassword: "Olvidaste tu contraseña?",
  managers: "Gerentes",
  phoneLinkSMS: "Teléfono (recibir un enlace por SMS).",
  emailReciveLink:
    "Correo electrónico (reciba un enlace por correo electrónico)",
  loginToStartProcess:
    "Por favor, proporcione su INICIO DE SESIÓN a continuación para comenzar el proceso de recuperación de contraseña",
  doLogin: "Iniciar sesión",
  toRecover: "Recuperar",
  recoveryPassword: "Recuperar contraseña",
  portuguese: "Portugués",
  spanish: "Español",
  english: "Inglés",
  // JOBSON - TRADUCAO
  verificationAccount: "Verificación de la cuenta",
  verificationEmail: "Verificacion de email",
  informPassword: "Introduce tu contraseña actual",
  // currentPassword: "Contraseña actual",
  oldPassword: "Introduzca una nueva contraseña",
  newPassword: "Nueva contraseña",
  rulePassword:
    "Ingrese una contraseña de 8 caracteres que contenga letras y números",
  // confirmPassword: "Confirmar nueva contraseña",
  // requiredInput: "Repite la contraseña",
  changePassword: "Cambiar contraseña",
  digitCodeBet: "Ingrese el código de apuesta",
  next: "Avance",
  cancelBet: "Cancelar apuesta",
  close: "Cerrar",
  confirmCancelBet: "Confirmar cancelación",
  code: "Código",
  digitPreBet: "Ingrese el código de pre-apuesta",
  validatePreBet: "Validar pre-apuesta",
  confirmPreBet: "Confirmar validación",
  pendent: "Pendiente",
  lost: "Perdidas",
  awarded: "Ganadoras",
  historic: "Histórico",
  sellCredit: "Vender crédito",
  search: "Buscar",
  notFoundBet: "No se encontraron apuestas",
  yes: "Sí",
  no: "No",
  currentBalance: "Saldo actual",
  limitSales: "Límite de ventas",
  remainingBalance: "Límite restante",
  weeekSales: "Ventas semanales",
  topClients: "Principales clientes",
  // unlimited: "Ilimitado",
  sales: "Ventas",
  commission: "Comisión",
  prizesPaid: "Primas pagadas",
  balance: "Saldo",
  user: "Usuario",
  period: "Período",
  date: "Fecha",
  qtdSales: "Qtd. Ventas",
  accurate: "Verificado",
  cancel: "Cancelado",
  prizes: "Pagadas",
  validated: "validado",
  notValidated: "No validado",
  deal: "Liquidación financiera",
  balanceDay: "Saldo por dia",
  balanceFinal: "Saldo final",
  grossValue: "Ingresos",
  salesCredit: "Ventas de crédito",
  resume: "Resumen",
  salesTotal: "Ventas total",
  totalCommission: "Comisión total",
  totalNet: "Neto total",
  active: "Activo",
  inactive: "Inactivo",
  betCancel: " cancelada",
  betCode: "Apuesta cod. ",
  betPlaced: " retenido",
  betPaid: " pagada",
  betAttencion: "¡Atención! Esta acción no se puede deshacer.",
  // cancel: "Cancelar",
  events: "Eventos",
  clients: "Clientes",
  // value: "Valor",
  return: "Retorno",
  result: "Resultado",
  // menuTable
  finalResult: "Resultado Final",
  overUnder: "Gols Acima/Abaixo",
  doubleChance: "Doble oportunidad",
  GoalsEuropeanHandicap: "Gols (Hándicap europeo)",
  bothMark: "Ambos puntúan",
  oneTwoBoth: "1X2 y Ambos",
  pointsUnderOver: "Puentos Más/Menos",
  firstPeriodWinner: "Ganador - 1º Set",
  // end menuTable
  paid: "Pagado",
  action: "Acciones",
  informNewPassword: "Ingrese una nueva contraseña a continuación",
  repeatNewPassword: "Repita la nueva contraseña",
  goHomePage: "Ir a la pagina principal",
  reset: "Reinicializar",
  goToWebsite: "Ir al sitio web",
  goToSports: "Ir a Deportes",
  goToCasino: "Ir al Casino",
  invitePlayer: "Invitar jugador",
  exit: "Salir",
  // balance: "Balance",
  // deposit: "Depósito",
  BALANCE: "BALANCE",
  availableToCashout: "DISPONIBLE PARA RETIRO",
  restrictBalance: "SALDO RESTRINGIDO",
  balanceAgent: "SALDO AGENTE",
  BONUS: "BONIFICACÍON",
  main: "Principal",
  specials: "Especiales",
  market: "Mercado",
  possibleReturn: "Posible retorno",
  allOdds: "Probabilidades totales",
  conference: "Conferencia",
  BETCONFERENCE: "BET CONFERENCE",
  NOVALIDFORAWARD: "(NO VÁLIDO PARA RECIBO DE PREMIOS)",
  tournament: "Torneo",
  // action: "Action",
  reverseAmount: "Importe inverso",
  pendentStatus: "Pendiente",
  missed: "Perdido",
  reimbursement: "Reembolso",
  right: "Bien",
  carres: "Trabaja con nosotros",
  contact: "Contáctenos",
  appClient: "Descargar App Client",
  appAgent: "Descargar App Agente",
  help: "Reglas",
  regulation: "Reglamento",
  terms: "Condiciones de uso",
  suspend: "Desativa Tu Conta",
  // responsibleGaming: "Juego Responsable",
  privacy: "Política de privacidad",
  bank: "Banco",
  bonus: "Bonificacíon",
  profile: "Perfil",
  updateBalance: "Actualizar saldo",
  HowRecoverPassword: "¿Cómo desea recuperar su contraseña?",

  // MenuNavigationAgent
  homeAgent: "Inicio Agente",

  //
  // Tradução Daniel
  //
  // BTN's (Padrão)
  BtnCancel: "Cancelar",
  BtnSave: "Guardar",
  BtnNext: "Avance",
  BtnDeposit: "Depositar",
  BtnWithdraw: "Retirar",

  // TAB's (Padrão)
  tabExtract: "Extracto",
  tabDeposit: "Depósito",
  tabWithdraw: "Retiro",

  // =========================================
  // Dashboard USER view: profile.vue - Perfil
  // =========================================

  // TABS
  personalDataTitleTabInfo: "Info",
  personalDataTitleTabSecurity: "Seguridad",

  // Dados Pessoais
  personalDataTitle: "Datos personales",
  personalDataHint: "Encuentre su información personal aquí.",
  personalDataFullName: "Nombre completo",
  // (Equivalente ao CPF - fica em aberto)
  personalDataDocument: "",
  personalDataBirthDate: "Fecha de nacimiento",

  // Dados de Contato
  contactDataTitle: "Datos de contacto",
  contactDataHint: "Encuentre su información de contacto aquí.",
  contactDataPhone: "Teléfono",
  contactDataEmail: "Correo Electrónico",

  // Dados Financeiros
  financialDataTitle: "Datos financieros",
  financialDataHint: "Encuentre su información financiera aquí.",

  // 'Tipo Chave PIX' e 'Chave PIX' ficam em aberto

  // Dados de Endereço
  addressDataTitle: "Datos de dirección",
  addressDataHint: "Encuentre la información de su ubicación aquí.",
  addressDataPostal: "Código Postal",
  addressDataAddress: "Direccion de casa",
  addressDataNumber: "Número",
  addressDataDistrict: "Barrio",
  addressDataComplement: "Complemento",
  addressDataCityStateTitle: "Ciudad - Estado",

  // Dados de Acesso
  credentialDataTitle: "Datos de acceso",
  credentialDataHint: "Encuentre su información de inicio de sesión aquí.",
  credentialDataLogin: "Acceso",
  credentialDataPassword: "Contraseña",
  credentialChangePassword: "Cambiar contraseña",

  // Autenticação de duas etapas
  twoStepsAuthTitle: "Verificación en dos pasos",
  twoStepsAuthHint:
    "Encuentre su información de verificación en dos pasos aquí.",
  twoStepsAuthAlertVerifyPhone:
    "Teléfono verificado | Nota: Para habilitar la verificación en dos pasos, debes verificar tu teléfono.",
  twoStepsAuthBtnVerifyPhone: "Verificar mi teléfono",

  // PERFIL - DIALOGS

  // PERSONAL DATA (DADOS PESSOAIS) - dialogEditPersonal.vue
  profileDialogTitle: "Editar datos personales",
  profileDialogTreatmentTitle: "Título",
  profileDialogFullName: "Nombre y apellido",
  // Equivalente ao CPF
  profileDialogDocument: "Documento Fiscal",
  profileDialogBirthDate: "Fecha de nacimiento",
  // BTN's Cancelar e Salvar

  // CONTACT DETAILS (DADOS DE CONTATO) - dialogEditContact.vue
  profileDialogContactTitle: "Detalles de contacto",
  profileDialogContactPhone: "Teléfono móvil",
  profileDialogContactEmail: "Correo electrónico",
  profileDialogContactEmailHint:
    "Para editar su correo electrónico, contáctenos.",
  // BTN's Cancelar e Salvar

  // FINANCIAL DATA (DADOS FINANCEIROS) - dialogEditFinancial.vue
  profileDialogFinancialTitle: "Datos financieros",
  // Formas de pagamento para o exterior ainda estão indefinidas
  profileDialogFinancialPixKeyType: "Tipo de Chave Pix",
  profileDialogFinancialPhone: "Teléfono",
  // BTN's Cancelar e Salvar

  // ADDRESS DATA (DADOS DE ENDEREÇO) - dialogEditAddress.vue
  profileDialogAddressTitle: "Datos de localización",
  profileDialogAddressPostal: "Código postal",
  profileDialogAddressHomeAddress: "Direccion de casa",
  profileDialogAddressNumber: "Número",
  profileDialogAddressDistrict: "Barrio",
  profileDialogAddressComplement: "Complemento",
  profileDialogAddressEstado: "Estado",
  profileDialogAddressCity: "Ciudad",
  // BTN's Cancelar e Salvar

  // ALTERAR SENHA
  // 1º Etapa
  profileDialogEditCredentialtitle: "Cambiar contraseña",
  profileDialogEditAlert: "Para continuar ingrese su contraseña actual.",
  profileDialogEditPassword: "Contraseña",

  // 2º Etapa
  profileDialogEditChangePasswordAlert:
    "Establezca una contraseña segura usando letras y números.",
  profileDialogEditNewPassword: "Nueva contraseña",
  profileDialogEditNewPasswordHint:
    "Ingrese una contraseña de 8 caracteres que contenga letras y números.",
  profileDialogEditNewPasswordConfirm: "Confirmar contraseña",
  // BTN's Cancelar e Salvar

  // =========================================
  // Dashboard USER view: bonus.vue - Bônus
  // =========================================

  // INFOS BONUS
  displayBonusValue: "Cantidad de Bonificación",
  displayeDeadline: "Fecha Limite",
  minimumQuotation: "Cotización mínima",
  targetValue: "Valor objetivo",
  qualifiedBets: "Apuestas calificadas",
  bonusReleaseGoal: "Objetivo de lanzamiento de bonificación",

  // (TEXTO) Regra do Bônus
  bonusRuleP1: "Realice su primer depósito y active la oferta de bonificación.",
  bonusRuleP2Part1:
    "Después de la consolidación de su primer depósito, se otorgará su Bono de apuesta del ",
  bonusRuleP2Part2: " % de su primer depósito hasta $",
  bonusRuleP3:
    "Solo será posible realizar apuestas de bonificación con un multiplicador mínimo de ",
  bonusRuleP4:
    "Para poder autorizar el Bono de Apuestas será necesario realizar apuestas que califiquen sobre el monto total del bono Concedido de su depósito, las apuestas que califiquen deben tener cotización mínima de ",
  bonusRuleP5:
    "Ejemplo: Bono de $20,00. Será necesario apostar $20,00 en partidos con cotización igual o superior a la ",
  bonusRuleP6:
    "Su apuesta calificada solo contará para la promoción de bonificación cuando terminen los partidos.",
  bonusRuleP7:
    "Después de cumplir la regla y finalizar los partidos, al día siguiente, el Bono de apuesta se acreditará en su cuenta como Valor de bono.",
  bonusRuleP8: "Sus bonificaciones de apuestas no se pueden retirar.",
  bonusRuleP9:
    "El usuario no puede realizar más de una apuesta de bonificación en la misma combinación: evento y tipo de apuesta.",
  bonusRuleP10:
    "Las devoluciones resultantes de los montos de las apuestas de bonificación se agregarán a su saldo disponible, pero los montos de las apuestas de bonificación no se incluirán en ninguna devolución.",
  bonusRuleP11:
    "Ej .: Apuesta de bonificación de $10,00 con probabilidades de 3,00. Si la apuesta gana, se añadirán $ ",
  bonusRuleP12: " a su cuenta.",

  // AUTOBONUS

  // REGRAS
  autoBonusTitle: "Normas",
  autoBonusP1: "Realice su primer depósito y active la oferta de bonificación.",
  autoBonusP2Part1:
    "Después de la consolidación de su primer depósito, su Bono de apuesta, desde ",
  autoBonusP2Part2: " % de su 1er depósito hasta $",
  autoBonusP3:
    "Solo será posible realizar apuestas de bonificación con un multiplicador mínimo de: ",
  autoBonusP4: "Sus bonificaciones de apuestas no se pueden retirar.",
  autoBonusP5:
    "El usuario no puede realizar más de una apuesta de bonificación en la misma combinación: evento y tipo de apuesta.",
  autoBonusP6:
    "Las devoluciones resultantes de los montos de las apuestas de bonificación se agregarán a su saldo disponible, pero los montos de las apuestas de bonificación no se incluirán en ninguna devolución.",
  autoBonusP7: "Ej .: Al depositar $10,00. $ ",
  autoBonusP8: " se agregarán automáticamente a su cuenta.",

  // ==========================================================
  // Dashboard USER view: dashboard/user/bank/index.vue - Banco
  // ==========================================================

  bankBalance: "Saldo",
  labelCurrency: "$",
  awardRescue: "Canje de recompensas",
  bankHistoric: "Histórico",

  // Simple-table
  simpleTableDate: "Fecha",
  simpleTableId: "ID",
  simpleTableOperation: "Operación",
  simpleTableValue: "Valor",

  // ===========================================
  // Dashboard USER view: bankOnline.vue - Banco
  // ===========================================

  // As TABS Extrato - Depósitos - Saques (Padrão) estão no topo deste bloco de tradução

  // Extract Online Datatable
  // extractHeaders
  extractOnlineHeaderDate: "Fecha",
  extractOnlineHeaderOperation: "Operación",
  extractOnlineHeaderValue: "Valor",

  // Deposit Online Datatable
  // DepositHeaders
  depositOnlineHeaderId: "ID",
  depositOnlineHeaderValue: "Valor",
  depositOnlineHeaderStatus: "Status",
  depositOnlineHeaderDepositDate: "Fecha de Deposito",
  depositOnlineHeaderDepositQrcode: "QR Code",

  // Withdraw Online Datatable
  // WithdrawHeaders
  withdrawOnlineHeaderId: "ID",
  withdrawOnlineHeaderValue: "Valor solicitado",
  withdrawOnlineHeaderStatus: "Status",
  withdrawOnlineHeaderKeyType: "Tipo de Clave",
  withdrawOnlineHeaderPixKey: "Clave Pix",
  withdrawOnlineHeaderDateRegister: "Fecha de Registro",

  // Select Label
  selectLabelTranslated: "Status do Depósito",

  // selectItems (Component)
  selectAll: "Todos",
  selectRequested: "Solicitado",
  selectConsolidated: "Consolidado",
  selectCanceled: "Cancelado",

  // ==========================================
  // Dashboard USER view: list-bet-online.vue - Apostas (Dashboard online)
  // ==========================================

  // Bet Online
  // Headers
  listBetOnlineHeaderId: "ID",
  listBetOnlineHeaderDateHour: "Fecha/Hora",
  listBetOnlineHeaderEvents: "Eventos",
  listBetOnlineHeaderAmount: "Valor",
  listBetOnlineHeaderPrize: "Retorno Financiero",
  listBetOnlineHeaderResultBet: "Resultado",
  listBetOnlineHeaderPaid: "Valor Pago",
  listBetOnlineHeaderAction: "Visualizar",

  // Select Label
  selectLabelBetOnlineTranslated: "Status Prêmio",
  // SelectItems
  selectAllbetOnline: "Todas",
  selectPaidsbetOnline: "Pagas",
  selectProcessingbetOnline: "Em processamento",

  // Search Label
  searchLabelBetonline: "Buscar",

  // v-chips
  chipIsLive: "en vivo",
  chipIsBonus: "bonificación",

  // RESUMO DO PERÍODO
  // Resumo Título
  periodSummaryTitle: "Resumen del período",
  periodSummaryValue: "Valor",
  periodSummaryPrizesPaid: "Primas pagadas",
  periodSummaryPossibleAwards: "Posibles premios",
  periodSummaryTotalPrizes: "Premios totales",

  // ==========================================
  // Dashboard USER view: list-bet.vue - Apostas
  // ==========================================

  myBetsTitle: "Mis Apuestas",

  // bet_arr.length => apostas
  betArrLengthBets: "apuesta(s).",
  betFromDate: "De",
  betToDate: "hasta",

  // list-bet search
  listBetLabelSearch: "Buscar",

  // Data Iterator - datainterator.vue
  // Alert Msg
  alertDataIteratorMyBets: "No se encontraron apuestas con sus filtros.",

  // Footer
  MyItemsPerPage: "elementos por página:",
  currentPage: "página",
  ofPages: "de",

  // CardBetDataInterator - index.vue (Component)
  cardBetDataPreBetNumber: "No.",
  cardBetDataPreBet: "Apuesta previa",
  cardBetDataPreBetEvents: "Eventos",
  cardBetDataPreBetOdd: "odd",
  cardBetDataPreBetTotalOdds: "Total odds",
  cardBetDataPreBetValue: "Valor",
  cardBetDataPrePossibleReturn: "Posible retorno",
  cardBetDataPreConference: "Conferencia",

  // Agent
  enterTheHashCode: "Introduzca el código hash de la apuesta:",
  confirmPayment: "Confirmar pago",
  payBet: "Pagar apuesta",
  hashCode: "Código hash",
  validCode: "Introduzca un código válido",
  statusBetDoesntWin: "Estado: La apuesta no gana.",
  statusBetWonConfirmToPay: "Estado: apuesta ganada, confirmar para pagar.",
  overview: "Descripción general",
  bets: "Apuestas",
  // historic: "History",
  // validatePreBet: "Validate Prebet",
  payPremium: "Pagar prima",
  // cancelBet: "Cancel bet",
  credit: "Crédito",
  // historic: "History",
  financial: "Financiero",
  extract: "Extraer",
  commissions: "Comisiones",
  // bank: "Bank",
  account: "Cuenta",
  // changePassword: "Change Password",
  // =======================================================
  // Dashboard AGENT view: registeredCustomers.vue - Apostas
  // =======================================================

  // Card "Digite o nome do Jogador"
  EnterPlayerNameTitle: "Buscar jugador",
  // Card Placeholder
  EnterNameOrPhone: "Nombre o teléfono",

  // Simple-Table
  sumPendent: "Pendiente",
  sumLost: "Pérdidas",
  sumWin: "Ganancias",
  sumComission: "Comisión",
  sumBet: "Apuestas",
  sumNetValue: "Valor de la Red",

  extractByDay: "Extracto agrupado por día:",
  previousBalance: "Saldo anterior",

  registeredCustomers: "Clientes registrados",

  //=============================================
  // Tradução Range Date - RangeDate.vue
  //=============================================

  // itemsWeek
  lastSevenDaysLable: "Últimos 7 días",
  currentWeekLable: "Esta semana",
  lastWeekLable: "Semana pasada",
  todayLable: "Hoy",
  yesterdayLable: "Ayer",

  // itemsHalfMonth
  lastFifteenDaysLable: "Últimos 15 días",

  // itemsMonth
  currentMonthLable: "Mes actual",
  lasttMonthLable: "Mes pasado",

  // DATEPICK prefix
  fromDateLable: "De:",
  toDateLable: "Hasta:",

  // DATEPICK locale
  localeDatepickLable: "es",

  // DATEPICK Format
  datePickerStartLable: "DD/MM/YYYY",
  datePickerFinalLable: "DD/MM/YYYY",

  // Select Range
  intervalsLable: "Intervalos",
  schedule: "Horario",
  type: "Tipo",
  client: "Cliente",
  printTime: "Tiempo de impresión",

  theBet: "Apuesta",
  theBets: "Apuestas",
  downloadPDF: "Descargar PDF",
  toPrint: "Imprimir",
  btnCopy: "Copiar",
  btnRefresh: "Actualizar",

  requested: "Solicitado",
  authorized: "Autorizado",
  consolidated: "Consolidado",
  canceled: "Cancelado",
  canceledCampaign: "Cancelada",
  tooltipCanceledCampaign:
    "Esta promoción ha sido cancelada por la plataforma. Los juegos incluidos ya no se pueden jugar a través de esta promoción.",
  expired: "Caducado",
  expiredCampaign: "Caducada",
  profit: "beneficio",
  errorOnForm: "Hay errores en el formulario, revise su información.",

  // dialog-deposit.vue
  depositTitle: "Depósito",
  depositLabel: "Valor ($)",
  depositPrefix: "$",
  joinBonus: "BONO POR DEPÓSITO",
  depositText: `Los depósitos se realizan a través de "método de pago". Es obligatorio tener registrado su Número de identificación.`,
  btnPix: "Generar Pix",
  btnDeposit: "Depositar",
  paymentTitle: "Pago",
  paymentText: `Para realizar el pago a través de "método de pix", escanee el código QR en la aplicación de su banco o haga clic en el botón para copiar el código.`,
  depositValue: "Valor del depósito: $",
  particleOr: "O",
  iconTitle: "Forma de pago",

  // dialog-withdraw
  withdrawTitle: "Retirar",
  withdrawText: "Previa solicitud, el retiro se enviará para su análisis.",
  withdrawTax: "Cargo por retiro: ",
  btnSend: "Mandar",
  withdrawLabel: "Valor ($)",
  withdrawPrefix: "$",

  maleTitle: "Sr.",
  femaleTitle: "Sra.",

  ThisFieldIsRequired: "¡Este campo es obligatorio!",
  repeatPassword: "Repite la contraseña",
  passwordRecover: "Restablecer contraseña",

  somethingWrong:
    "Algo salió mal, si el error persiste, comuníquese con nuestro soporte.",

  reviewInformation: "Hay errores en el formulario, revise su información.",
  brazil: "Brasil",
  southAmerica: "América del Sur",
  europe: "Europa",
  international: "Internacional",
  asia: "Asia",
  oceanía: "Oceanía",
  africa: "África",
  unitedStates: "Estados Unidos",
  europe2: "Europa 2",
  europe3: "Europa 3",
  southAmerica2: "América del Sur 2",
  middleEast: "Oriente Medio",
  ufcBoxing: "UFC / Boxeo",
  libertadores: "Libertadores",

  responsibleGaming: "Juego responsable",
  accountSuspend: "Cuenta suspendida",
  autoExclude: "Excluir la cuenta",
  confirm: "Confirmar",
  cantBeUndone: "No se puede deshacer esta acción.",
  suspendDescription:
    "Si desea tomar un breve descanso de su actividad de apuestas y juegos por un período corto de tiempo, puede suspender su cuenta por hasta seis semanas. La suspensión de su cuenta aún le permite hacer retiros, pero no depósitos ni apuestas.",
  autoExcludeDescription:
    "Utilice la autoexclusión si cree que corre el riesgo de desarrollar un problema de juego o si cree que actualmente tiene un problema de juego. La autoexclusión le impide apostar con nosotros durante un período específico entre 6 meses y 5 años.",
  open: "Abrir",
  closed: "Cerrada",
  monday: "Lunes",
  tuesday: "Martes",
  wednesday: "Miércoles",
  thursday: "Jueves",
  friday: "Viernes",
  saturday: "Sábado",
  sunday: "Domingo",
  updateSystem: "Sistema actualizado.",
  somethingDidntWork:
    "Algo no funcionó correctamente. Actualice su página o, si el problema persiste, comuníquese con nuestro soporte",
  copyNotification: "¡Copia con éxito!",
  textRadioConfirmRegister:
    "Me gustaría recibir la confirmación de registro para:",
  textRadioRecoveryLogin:
    "Quiero recibir la recuperación de inicio de sesión para:",
  viewBets: "Ver apuestas",
  gain: "Ganancia",
  betAmount: "monto de la apuesta",

  reversalAmount: "Importe de reversión",
  newPlayer: "Agregar nuevo jugador",
  rewardRedemption: "Resgate de prêmio",

  breaks: "Descansos",
  invalidTime: "Invalid time",
  weeklyCalculation: "Cálculo semanal",
  currentCalculation: "Cálculo actual",
  from: "De",
  until: "Hasta",
  show: "Show",
  sum: "Suma",
  nullData: "No se encontraron datos en el período seleccionado.",
  formRegisterTitlePersonalData: "Datos Personales",
  formRegisterTitleAccessCredential: "Credencial de Acceso",

  indicatedBy: "Indicado por",
  recoverLoginMsg:
    "Ingrese su CPF a continuación y le enviaremos un mensaje con su nombre de usuario.",
  recoverLoginBtn: "Recuperar Iniciar sesión",

  interval: "Intervalo",
  filters: "Filtros",
  toClean: "Limpiar",
  toFilter: "Filtro",
  searchByName: "Buscar por nombre",
  searchPlayers: "Buscar Jugadores",
  paybet: "Pagar Apuesta",
  periodSummaryPrizesToPaid: "Premios a pagar",
  simple: "Simple",
  double: "Doble",
  triple: "Triple",
  multiple: "Multiple",
  firstHalf: "Primera mitad",
  firstHalfExtension: "Extensión de la primera mitad",
  secondHalf: "Segunda mitad",
  secondHalfExtension: "Extensión de la segunda mitad",
  sanctions: "Sanciones",
  break: "Intervalo",
  totalTime: "Tiempo Total",
  fullPeriodAfterOvertime:
    "Período completo después de las horas extraordinarias",
  fullPeriodAfterPenalties: "Período completo después de las sanciones",
  matchNotStarted: "Partido no iniciado",
  firstQuarter: "1er Cuarto",
  secondQuarter: "2nd Cuarto",
  thirdQuarter: "3er Cuarto",
  fourthQuarter: "4th Cuarto",
  overtime: "horas extraordinarias",
  firstMap: "1er Mapa",
  secondMap: "Segundo Mapa",
  thirdMap: "3er Mapa",
  fourthMap: "4th Mapa",
  fifthMap: "5th Mapa",
  endOfMatch: "Fin de la Partida",
  firstSet: "1er conjunto",
  secondSet: "2nd Set",
  thirdSet: "3er conjunto",
  fourthSet: "4th Set",
  fifthSet: "5th Set",
  goldenSet: "Tie Break",
  firstInning: "1º Turno",
  secondInning: "2º Turno",
  thirdInning: "3º Turno",
  fourthInning: "4º Turno",
  fifthInning: "5º Turno",
  sixtyInning: "6º Turno",
  seventhInning: "7º Turno",
  eighthInning: "8º Turno",
  ninthInning: "9º Turno",
  extraInning: "Turnos Extras",
  firstRound: "1º Ronda",
  secondRound: "2º Ronda",
  thirdRound: "3º Ronda",
  fourthRound: "4º Ronda",
  fifthRound: "5º Ronda",
  sixtyRound: "6º Ronda",
  seventhRound: "7º Ronda",
  eighthRound: "8º Ronda",
  ninthRound: "9º Ronda",
  tenthRound: "10º Ronda",
  eleventhRound: "11º Ronda",
  twelfthRound: "12º Ronda",
  current_balance: "Balance actual",
  previous_balance: "Balance Anterior",
  amlPolicy: "Política AML",
  betMinimum: "Apuesta mínima",
  betMaximum: "Apuesta máxima",
  activiteMinutes: "Minutos de actividad",
  minimumDeposit: "Depósito mínimo",
  maximumDeposit: "Depósito máximo",
  depositInterval: "Intervalo de depósito",
  depositLimitValue: "Valor límite de depósito",
  userLimitsSubtitle: "Encuentra límites de apuesta, depósito y actividad aquí",
  userLimits: "Límites de usuario",
  useTimeLimits: "Usar límites de tiempo",
  depositLimits: "Límites de depósito",
  bettingLimits: "Límites de apuestas",
  editLimits: "Editar límites",
  depositLimitValues: "Valores límite de depósito",
  depositTimeLimit: "Límite de tiempo de depósito",
  twentyFourHours: "24 horas",
  fortyEightHours: "48 horas",
  sevenDays: "7 días",
  thirtyDays: "30 días",
  twentyMinutes: "30 Minutos",
  sixtyMinutes: "60 Minutos",
  ninetyMinutes: "90 Minutos",
  oneHundredTwentyMinutes: "120 Minutos",
  noLimits: "Sin límites",
  noLimitBet: "Apuesta sin límite",
  noActivityLimit: "Sin límite de actividad",
  noDepositLimit: "Sin límite de depósito",
  noDepositTimeLimit: "Sin límite de tiempo de depósito",
  youUsedTheSiteFor: "Usaste el sitio para",
  doYouWantToContinueBrowsing: "minutos. ¿Quieres seguir navegando?",
  continue: "Continuar",
  timeOfUseController: "Controlador de tiempo de uso",
  messages: "Mensajes",
  description: "Descripción",
  noNewMessagesAtMoment: "Actualmente no tienes mensajes nuevos",
  message: "Mensaje",
  validatePromotion: "Validar Promoción",
  bonusAndPromotions: "Bonificaciones y promociones",
  promotionCode: "Código de promoción",
  registerPromotionalCode: "Registrar código promocional",
  firstDepositBonus: "Bono por primer depósito",
  promotionRules1:
    "Un cupón de promoción solo se puede canjear una vez por usuario.",
  promotionRules2:
    "Los cupones promocionales se pueden cerrar en cualquier momento, tienen una fecha de inicio y finalización, e incluso dentro del período de canje, puede tener una limitación en la cantidad de personas que pueden canjearlo",
  sendThePromotionCodeHere: "Envíe el código de promoción aquí:",
  rulesAndConditionsOfPromotions: "Reglas y condiciones de las promociones",
  validate: "Validar",
  invalid: "Inválido",
  addPunter: "Añadir apostador",
  namePlayer: "Nombre del jugador",
  doYouWantToRemoveInvalidEvents: "¿Desea eliminar los eventos no válidos?",
  accomplish: "Lograr",
  new: "NUEVA",
  afterPerformingThe: "Después de realizar el",
  betSendTheNewIDtoPunter:
    " apuesta, envía el nuevo identificador (ID) al apostador",
  thereAreNoValidEventsForThisTicket: "No hay eventos válidos para este ticket",
  placeNewBet: "Realizar NUEVA apuesta",
  checkInvalidBets: "Verificar apuestas inválidas",
  textBet: "Apuesta",
  gameName: "Nombre del Juego",
  bonusRuleP13:
    "Para realizar un retiro, debe haber realizado al menos un depósito.",
  autoBonusP9:
    "Para realizar un retiro, debe haber realizado al menos un depósito.",
  multipler: "Multiplicador",
  cashOut: "Retirar",
  noBetsFound: "No se han encontrado apuestas",
  pending: "Pendientes",
  resolved: "Resueltas",
  closeBet: "Cerrar",
  dashboard: "Tablero",
  casino: "Casino",
  videoSlots: "Slots en Vídeo",
  liveCasino: "Casino en Vivo",
  scratch: "Raspadita",
  tableGames: "Juegos de Mesa",
  comingSoon: "Próximamente",
  toPlayInTheCasinoRegistorOrLogin:
    "Para jugar en el cassino, Regístrate o inicia sesión.",
  play: "Jugar",
  playNow: "Jugar ahora",
  funPlay: "Jugar Grátis",
  onMaintenance: "Sitio web en mantenimiento",
  onMaintenanceMessage:
    "Para servirle mejor, estamos en mantenimiento. Por favor, inténtelo de nuevo más tarde",
  roulette: "Ruleta",
  unauthorizedLiveStream:
    "Debe iniciar sesión para acceder a la transmisión en vivo.",
  unavailableTracker: "Rastreador no disponible para este evento",
  bettingTicket: "Boleto de apuestas",
  placeYourBet: "Haz tu apuesta",
  shareCoupon: "Compartir mi Boleto",
  expiredEvents: "Eventos no Disponibles",
  expiredEventsDetail: "Estos eventos no están disponibles: ",
  yesContinue: "Todas maneras, continúe",
  cleanCart: "Vaciar Carrito",
  viewInCasaDeApostas: "Ver en la Casa de Apostas",
  pendingWithdraw: "Pendiente",
  cancelWithdraw: "Cancelar Retiro",
  cancelWithdrawExplanation:
    "Este retiro está pendiente. Si solicita la cancelación, la cantidad solicitada se agregará a su saldo.",
  game: "Juego",
  wallet: "Carteira Pay4Fun",
  myPromotions: "Mis Promociones",
  promotions: "Promociones",
  promotionMaxBonus: "$ {max_bonus} de Bonificación",
  noPromotionForYou: "Actualmente no hay promociones disponibles.",
  progressTooltip: "Aún tienes que apostar $ {betValueLeft}.",
  noActivePromotion: "No hay promociones activas en este momento.",
  useCode: "Utilizar Código",
  rolloverProgressDescription:
    "Puede seguir el progreso de su bonificación. ¡Al completar la transferencia, podrá transferir su saldo de bonificación a su saldo!",
  rolloverBetValue: "Valor Apuestas",
  progress: "Progresso da Promocion",
  transferBalance: "Transferir Saldo",
  rolloverPercentageMissing: "Falta {percentageMissing}%",
  rolloverCompleted: "Rollover Terminado",
  goBack: "Vueltar",
  joinPromotion: "Adherirse Promoción",
  knowMore: "Saber Mas",
  totalRollover: "Rollover Total",
  bonusGained: "Bonificación Ganada",
  activePromotions: "Promociones Activas",
  transformYourBonusIntoMoney: "Convierte tu bono en efectivo:",
  expiresIn: "Expira en",
  expiredIn: "Expirou en:",
  transfer: "Transferir",
  promoCode: "Codigo Promocional (Opcional)",
  promoCodeWithoutOptional: "Participar en la Promoción",
  theDeposit: "el depósito",
  theAdmission: "la adhesión",
  attention: "Aviso",
  when: "Cuando",
  promotionIsConfirmedDeposit:
    "se confirma, su saldo de bonificación se restablecerá y se iniciará un nuevo proceso de rollover.",
  promotionIsConfirmedOther:
    "se confirma, su saldo de bonificación se restablecerá y se iniciará un nuevo proceso de rollover.",
  ifYouContinueAnd: "Si continúa y",
  currentlyYouGotThisPromotion:
    "Actualmente tienes activa la siguiente promoción:",
  isConfirmedThisWillBeYourNewPromotionDeposit:
    "ser confirmado, esta será tu nueva promoción:",
  isConfirmedThisWillBeYourNewPromotionOther:
    "ser confirmado, esta será tu nueva promoción:",
  promotionalCodes: "Códigos Promocionales",
  promotionHistory: "Historial de Promociones",
  noPromotionHistory: "No hay promociones anteriores.",
  finishedPromotion: "Cerrado",
  promotionDetail: "Detalle De La Promoción",
  seeDetail: "Ver Detalle",
  nextBalance: "Saldo Subsiguiente",
  operationName: "Nombre da Operación",
  promotionUseDetail: "Detalles de la Promoción",
  actions: "Acciones",
  seeRules: "Ver reglas",
  promotionRules: "Reglas de Promoción",
  afterTransfer:
    "Después de la transferencia, la promoción terminará, y si queda algún saldo restante, se perderá el monto.",
  afterTransferAnotherDialog:
    "Después de la transferencia, la promoción terminará.",
  howItWorks: "Como Funciona",
  none: "Ninguna",
  firstDepositPromotion: "1º Depósito",
  depositPromotion: "Depósito",
  promotionBetsAfterTransfer:
    "Si alguna apuesta relacionada con esta promoción aún está pendiente, ya no será válida.",
  gamingType: "Tipo de Jogo",
  totalAwards: "Total Awards",
  totalComission: "Total Comission",
  casinoAndBetting: "Casino y Apuestas",
  sportsBetting: "Apuestas Deportivas",
  noGamesFoundWhileSearching:
    "No se han encontrado juegos. Intenta ajustar tu término de búsqueda.",
  noGamesFound: "No se han encontrado juegos.",
  doingLogin: "Iniciando Sesión",
  brazilCashFooter:
    "Brasil Cash es una forma rápida y segura de realizar sus depósitos a través de PIX. ¡Después del pago, el saldo se acreditará al instante!",
  brasilCashFooter2:
    "Brasil Cash es una empresa que presta sus propios servicios de tecnología como institución de pago y sub-acreedor, incluso a través de POS (máquina de tarjetas).",
  pixlancecertoFooter:
    "LanceWallet es una forma rápida y segura de realizar sus depósitos a través de PIX. ¡Después del pago, el saldo se acreditará al instante!",
  startingSoon: "Comienza en {minutes} minutos",
  clientGains: "Cliente recibe",
  verification: {
    pageName: "Verificar",
    document: {
      name: "Verificación de Identidad",
      description: `Por favor envíe su documento de identidad y una foto clara del
      su rostro. Todos los documentos deben estar en una superficie plana con
      las 4 esquinas dentro del marco. Toda la información debe ser clara y
      identificable.`,
      acceptedDocuments: "Documentos aceptados para verificación:",
      alert:
        "Todos los datos están encriptados y almacenados de forma segura. <br /> Una vez editados, sus datos no se pueden cambiar.",
      possibleDocuments: {
        passport: "Passaporte",
        driversLicense: "Cartera de Motorista",
        identity: "Cédula de Identidad con CPF",
        workCard: "Tarjeta de Trabajo con CPF",
      },
      inputs: {
        documentFront: "Prueba de Identidad (Frente)",
        documentVerse: "Prueba de Identidad (Reverso)",
        faceBiometry: "Imagen de La Cara",
      },
      denied: {
        someMotives:
          "La desaprobación de la verificación de documentos puede deberse a algunos factores, tales como:",
        motive1:
          "Documentos borrados, arrugados, ilegibles, es decir, fuera de los estándares de aceptación.",
        motive2: "Documentos de terceros.",
        motive3: "Fotos no compatibles, borrosas, sin iluminación adecuada.",
        motive4: "Imágenes de fondo llenas de información.",
        doubts:
          "Puede intentar ponerse en contacto con nuestro soporte si tiene alguna duda. Lo sentimos, pero su verificación fue rechazada.",
      },
      alertMessage: {
        inProgress:
          "Sus documentos ya han sido enviados, espere mientras procesamos la validación.",
        finished: "¡Todo cierto! Ha verificado con éxito su documentación.",
        denied:
          "Su documentación no fue aprobada, algunas razones pueden haber influido.",
      },
      allowedTypes:
        "Se aceptan los siguientes tipos de archivos: .png, .jpg, .pdf",
      sizeError: "La imagen es mayor a 900KB",
      minWidth: "El ancho mínimo para la imagen del documento es 1000px",
      sizeSumError:
        "La suma de los tamaños de las imágenes no puede ser superior a 2.2MB.",
      faceBiometryMinWidth: "A largura mínima para una foto de rosto é 250px.",
      faceBiometryMinHeight:
        "Una altura mínima para una foto de rosto é 250px.",
      documentNotVertical: "La imagen no debe estar vertical ni inclinada.",
      nothingSelected: "Ningún archivo seleccionado",
      filesDetail:
        "Las fotos de prueba de identidad deben enviarse en formato apaisado (horizontal) y deben tener al menos 1000 píxeles de ancho. La foto de la cara debe ser clara, con una resolución mínima de 250x250 píxeles.",
      fileImgSame: "Enviar un archivo de IMAGEN igual que el documento Frontal",
    },
    bank: {
      name: "Verificación Bancaria",
      description:
        "Su pix key debe pertenecer a uno de los bancos autorizados:",
      alert: {
        success: "Verificación bancaria completada con éxito.",
        inProgress:
          "La verificación bancaria está en curso. Por favor, espere un momento.",
      },
    },
    email: {
      name: "Email",
      btnResendVerify: "Reenviar correo electrónico de verificación",
      descriptionVerify: {
        text1:
          "¡Cuando confirmes tu correo electrónico, recibirás promociones exclusivas de nuestra plataforma!",
        text2:
          "Además, su usuario será reconocido en nuestro sistema y nuestro equipo de soporte ",
        text3: "siempre estará disponible si es necesario.",
      },
      tipVerify: {
        title: "Consejos:",
        tip1:
          "¡Al solicitar el reenvío de un correo electrónico, siempre verifique el último correo electrónico enviado!",
        tip2:
          "Verifique su cuenta haciendo clic en el enlace enviado por correo electrónico.",
        tip3: "¡Recuerda revisar tu carpeta de correo no deseado y/o spam!",
        tip4:
          "Si no lo has recibido, puedes solicitar otro después de 1 minuto.",
      },
      successMessage: "¡Su cuenta ha sido verificada! ¡Felices apuestas!",
    },
    phone: {
      name: "Teléfono",
      btnVerify: "Enviar código",
      descriptionSecurityVerify: {
        text1:
          "Verifica tu número de teléfono para garantizar la seguridad de tu cuenta.",
        text2:
          "Además, al verificar, puede habilitar o deshabilitar la <strong>verificación en dos pasos</strong> en Perfil, Seguridad.",
      },
      descriptionPhoneVerify: {
        title: "<strong>¿Cómo reviso mi teléfono?</strong>",
        text1:
          "Haz clic en Enviar código, luego recibirás un código por SMS en tu teléfono registrado.",
        text2: "Ingresa el código en los campos y espera.",
        text3: "Si no recibes el código o este caduca, solicita uno nuevo.",
      },
      successMessage: "¡Tu teléfono ha sido verificado exitosamente!",
    },
    status: {
      actionNeeded: "Acción Necesaria",
      pendent: "Pendiente",
      finished: "Terminado",
      inProgress: "En Progreso",
      denied: "Denegado",
    },
  },
  finalWinner: "Ganador Final",
  winner: "Ganador",
  verificationAlertMessage:
    "Hay uno o más cheques pendientes. Realiza las comprobaciones necesarias para realizar retiros.",
  affiliatesPayments: {
    linkPlayer: "Vincular Jogador",
    transfers: "Transferências",
    invoiceEmission: "Emisión de Factura",
    insertPlayerAccount:
      "Ingrese su nombre de usuario y contraseña para su cuenta de jugador que recibirá pagos.",
    linkedPlayer: "Jogador Vinculado",
    successLink: "Cuenta de jugador vinculada con éxito.",
    infoLink:
      "Vincular una cuenta de jugador. Allí recibirá el pago de su comisión.",
    linkError:
      "Se produjo un error al intentar encontrar la información de la cuenta vinculada.",
    paymentReferringMonth: "Pagos referentes a",
  },
  casinoBetting: {
    setDateRange: "Necesita establecer el intervalo de fechas.",
    loadingBets: "Cargando apuestas...",
    bet: "Apuesta",
    bets: "Apuestas",
    prize: "Premio",
    prizes: "Premios",
    betRefund: "Reembolso de Apuesta",
    betsRefund: "Reembolsos de Apuestas",
    prizeRefund: "Reembolso del Premio",
    prizesRefund: "Reembolsos del Premios",
    freespinPrize: "Premio de Freespins",
    profit: "Beneficio",
    allGames: "todos los juegos",
    date: {
      last24Hours: "Últimas 24 horas",
      last48Hours: "Últimas 48 horas",
      last7Days: "Los últimos 7 días",
      dateInterval: "Intervalo de Fechas",
    },
    headers: {
      dateAndHour: "Fecha y hora",
      transactionId: "ID Transacción",
      roundId: "ID Ronda",
    },
  },
  newCasino: {
    unloggedAtGame:
      "Para jugar <b>{game}</b> y más, inicia sesión o crea tu cuenta.",
    showingGamesProgress: "Mostrando {current} de {total} juegos",
    loadMore: "Carga Más",
    pageTitle: {
      providers: "Proveedores de juegos Casno",
      provider: "{provider}",
      category: "{category}",
      game: "{game}",
    },
    providers: "Proveedores",
    games: "Juegos",
    gamesFavorites: "Juegos favoritos",
    btnFavorite: "Favorito | Favorito",
    relatedGames: "Juegos Relacionados",
    noProvidersFound: "No se encontraron proveedores.",
    noCategoriesFound: "No se encontró ninguna categoría.",
    noGamesFoundLobby: "No se encontró ningún juego.",
    thisMasculine: "esse",
    thisFeminine: "essa",
    withFilters: " con estos filtros.",
    noGamesFound:
      "No se encontraron juegos para {thisPronoun} {model}{withFilters}",
    noGamesFoundFavorite: "Aún no has agregado ningún juego a tus favoritos.",
    category: "categoría",
    categories: "Categorías",
    provider: "proveedor",
    others: "otros",
    orderBy: "Ordenar por",
    volatility: {
      name: "Volatilidad",
      tooltip: `La volatilidad la proporcionan los proveedores de juegos.
      Esto se utiliza para indicar a los jugadores con qué frecuencia
      cómo la tragamonedas asigna los pagos y qué tan altos podrían
      esperar los pagos.`,
      high: "Alta",
      "very-high": "Muito alta",
      "medium-high": "Média-alta",
      medium: "Média",
      "low-medium": "Média-baixa",
      low: "Baixa",
    },
    rtp: {
      tooltip: `RTP: El retorno al jugador, o RTP, en cualquier juego,r
      es el porcentaje esperado de montos apostados que
      un juego específico volverá al jugador en el transcurso de
      un período de tiempo.`,
    },
    search: {
      inputLabel: "¿Que quieres jugar?",
      recentSearches: "Búsquedas recientes",
      noRecentSearches: "No hay búsquedas recientes",
      searchFavoritesGames: "¡Busca aquí tus juegos favoritos!",
      removeAllSearches: "Limpiar todo",
      gameNotFound: "Juego no encontrado",
      verifySearchTerm:
        "Asegúrese de que el nombre sea correcto o busque otra palabra clave.",
      toPlayDo: "Para jugar el juego,",
      createAnAccount: "crea una cuenta",
    },
    freespins: {
      detail: "Detalles",
      expiresIn: "Caduca en {hour}h y {minute}m",
      gainFreeRounds: "Ganhe rodadas grátis!",
      claimDate: "Fecha de reclamo",
      rules: {
        titleDialogDepositCampaign: "Reglas de campaña",
        first:
          "1. La participación en la campaña implica la plena aceptación de sus términos y condiciones.",
        second:
          "2. El bono solo es válido para clientes registrados en el sitio que reclamar la campaña de giros gratis hasta la fecha de vencimiento.",
        third:
          "3. El bono solo es válido para los juegos contenidos en la campaña.",
        fourth:
          "4. Para aprovechar la promoción, después de activar la campaña, vaya al menú Promociones activas y haga clic en Jugar.",
        fifth:
          "5. Esta promoción puede generar un rollover de hasta 100x.",
        sixth: "6. ¡Diviértete con tus giros gratis!",
      },
      noCampaignFoundForGame:
        "No se encontraron campañas para el juego buscado.",
      roundsClaimed: "Rondas ganadas ",
      roundsQuantity: "Número de Rondas",
      noCampaignsAvailable:
        "No hay campañas de giros gratis disponibles actualmente.",
    },
  },
  firstPasswordRegistration: {
    rules: {
      description: "Tu contraseña debe cumplir con estos requisitos:",
      oneUppercaseLetter: "Se requiere al menos una letra mayúscula",
      oneLowercaseLetter: "Se requiere al menos una letra minúscula",
      oneLowerAndUppercaseLetter:
        "Se requiere al menos una letra mayúscula y una minúscula",
      oneSpecialCharacter:
        "Se requiere al menos un carácter especial (#?!@$%^&*-)",
      oneNumber: "Se requiere al menos un número",
      eightCharacters: "La contraseña debe tener exactamente 8 caracteres",
      confirmation: "La contraseña y la confirmación deben coincidir",
      betweenEightAndTwelveCharacters:
        "La contraseña debe tener entre 8 y 12 caracteres",
    },
  },
  fullscreen: "Pantalla Completa",

  goToMyPromotions: "Ir a Mis Promociones",
  newRegister: {
    registerToBet: "¡Regístrate para apostar!",
    welcome:
      "<strong>¡Bienvenido a nuestra plataforma, {playerName}! &#127881;</strong>",
    infoLoginAndSupport:
      "Su inicio de sesión se realizará utilizando la misma dirección de correo electrónico utilizada durante el registro. Si tiene alguna pregunta, estaremos encantados de ayudarle.",
    makeYourDeposit: "¡Haz tu primer depósito y felices apuestas! &#128526;",
    agreeAdulthood:
      "Al registrarte, aceptas que tienes al menos 18 años de edad y aceptas el ",
    andThe: " y el ",
    emailsDontMatch: "Los correos electrónicos no coinciden",
    emailLabel: "Correo electrónico (ingrese un correo electrónico válido",
    emailLabelTooltip:
      "Este correo electrónico se utilizará como inicio de sesión de su cuenta.",
  },
  confirmEmail: "Revisa mi e-mail",
  verifyEmailBeforeWithdraw:
    "Para retirar, necesita verificar su correo electrónico.",
  verifySmsToken: {
    phoneVerification: "Verifica tu teléfono",
    twoStepsAuthentication: "Verificación en dos pasos",
    insertTokenHere:
      "Se ha enviado un código a su teléfono celular registrado. <br /> Insértelo aquí.",
    invalidToken: "Código no válido",
    resendToken: "Reenviar código",
    resendTokenTimer: "Reenviar código ({segundos} seg)",
    deactivateTwoStepsAuthentication:
      "Puedes desactivar esta verificación en Perfil > Seguridad",
    recommendActivateTwoStepsAuthentication:
      "Haga clic aquí para habilitar la verificación de dos pasos al iniciar sesión (recomendamos garantizar la seguridad de su cuenta)",
  },
  noDataText: "No hay datos",
  noResultsText: "No hay datos para esta búsqueda",
  changeContactInfo: {
    emailAction: "Confirmación de cambio de correo electrónico",
    phoneAction: "Confirmación de cambio de teléfono",
    loginChangeAfterEmailChange:
      "Cuando modifica su correo electrónico, su inicio de sesión se cambiará al nuevo correo electrónico.",
  },
};
export default es;
